// extracted by mini-css-extract-plugin
export default {"form":"Navigation_form__YibKz","characterDisplay":"Navigation_characterDisplay__KAUBM","img":"Navigation_img__CMSjH"};